import { render, staticRenderFns } from "./EditRoles.vue?vue&type=template&id=d1815664&"
import script from "./EditRoles.vue?vue&type=script&lang=js&"
export * from "./EditRoles.vue?vue&type=script&lang=js&"
import style0 from "./EditRoles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports